(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[167],{

/***/ 53372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useMobileMenuState; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59938);


/**
 * Global and shared store for the mobile menu.
 * Avoid using directly - use the `useMobileMenu` hook instead
 */
const useMobileMenuState = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(set => ({
  isOpen: false,
  setIsOpen: isOpen => set({
    isOpen
  })
}));

/***/ }),

/***/ 48564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ breakpoints; },
  "J": function() { return /* reexport */ sizes; }
});

;// CONCATENATED MODULE: ./src/constants/constants.ts
const breakpoints = {
  /**
   * Mobile devices. Use orientation media queries for landscape styling
   */
  xs: 767,

  /**
   * Small tablets
   */
  sm: 768,

  /**
   * Large tablets, small laptops
   */
  md: 1024,

  /**
   * Desktops, laptops
   */
  lg: 1367,

  /**
   * Wide screens
   */
  xl: 1730
};
const sizes = {
  // Limit content
  contentMaxWidth: 1690,
  headerHeightDesktop: 70,
  // Limit page width. Background colors etc.
  pageMaxWidth: 1690,
  // Header checkout
  headerHeightCheckout: 93,
  checkoutMinHeaderHeight: 130,
  content: 'min(88vw, 1690px)',
  // Default Width for side Drawer
  drawerWidth: 480,
  mobileDrawerWidth: 300,
  // Search bar height
  searchHeight: 46
};
const aspectRatios = {
  imageProduct: '2475 / 3262',
  imageModel: '2 / 3'
};
;// CONCATENATED MODULE: ./src/constants/index.ts


/***/ }),

/***/ 48167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Standard; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.5_zwnwwcpulpacxjlmvctaxclnzi/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(97212);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/services/cms/index.ts + 3 modules
var cms = __webpack_require__(94272);
// EXTERNAL MODULE: ../../packages/ui/src/index.tsx + 260 modules
var src = __webpack_require__(95685);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N10Meta/components/Usp/animations.ts
const animationOptions = {
  fade: {
    initial: {
      opacity: 0,
      position: 'absolute'
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.5
      }
    },
    animate: {
      opacity: 1,
      transition: {
        duration: 0.5,
        delay: 0.5
      }
    }
  },
  none: {
    initial: {
      display: 'block'
    },
    exit: {
      display: 'none'
    },
    animate: {
      display: 'block'
    }
  }
};
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-use@17.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(34176);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-use@17.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/react-use/esm/useInterval.js
var useInterval = __webpack_require__(77286);
// EXTERNAL MODULE: ../../node_modules/.pnpm/framer-motion@7.6.19_biqbaboplfbrettd7655fr4n2y/node_modules/framer-motion/dist/es/render/dom/motion.mjs + 110 modules
var motion = __webpack_require__(76150);
// EXTERNAL MODULE: ./src/shared/utils/jsx/index.ts + 3 modules
var jsx = __webpack_require__(16101);
// EXTERNAL MODULE: ./src/components/features/Navigation/components/N10Meta/components/Usp/Usp.module.css
var Usp_module = __webpack_require__(85980);
var Usp_module_default = /*#__PURE__*/__webpack_require__.n(Usp_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.1.5_iydcyk4gah44gajk2m3r5bwf3i/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(89992);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N10Meta/components/Usp/Usp.tsx









/**
 * Takes a list of USP's and
 * loops through them. Animation
 * properties can be controlled.
 */
const Usp = /*#__PURE__*/(0,react.memo)(_ref => {
  let {
    uspItems = [],
    animationDelay = 5000,
    animationType = animationOptions.fade
  } = _ref;
  const {
    0: shownItem,
    1: setShownItem
  } = (0,react.useState)(0);
  const {
    0: paused,
    1: setPaused
  } = (0,react.useState)(false);
  const {
    0: isTabFocus,
    1: setIsTabFocus
  } = (0,react.useState)(false);
  const isMobile = (0,useMedia/* default */.Z)('(max-width: 767px)', false); // On mobile, only show first USP item (no rotation)

  const shouldAnimate = !isMobile && uspItems.length > 1;
  (0,useInterval/* default */.Z)(() => {
    setShownItem(prev => ++prev % uspItems.length);
  }, paused || !shouldAnimate ? null : animationDelay);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    className: (Usp_module_default()).uspContainer,
    onMouseOver: () => setPaused(true),
    onMouseOut: () => setPaused(false),
    onBlur: event => {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        setIsTabFocus(false);
      }
    },
    onKeyDown: event => {
      if (event.code === 'Tab') {
        setIsTabFocus(true);
      }
    },
    children: isTabFocus ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (Usp_module_default()).wrapper,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
        className: (Usp_module_default()).accesibilityUspDisplay,
        children: uspItems.map(usp => (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          className: (Usp_module_default()).liWrapper,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Usp */.Dy, {
            uspItem: usp
          })
        }, (0,jsx/* weakKey */.RU)(usp)))
      })
    }) : isMobile ? // On mobile, show only the first USP item without animation
    uspItems.length > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Usp */.Dy, {
      uspItem: uspItems[0],
      shade: "light"
    }) : uspItems.map((usp, index) => (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
      variants: animationType,
      animate: shownItem === index ? 'animate' : 'exit',
      style: {
        pointerEvents: shownItem !== index ? 'none' : 'auto'
      },
      initial: "initial",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Usp */.Dy, {
        uspItem: usp,
        shade: "light"
      })
    }, (0,jsx/* weakKey */.RU)(usp)))
  });
});
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N10Meta/components/Usp/index.ts

;// CONCATENATED MODULE: ./src/shared/utils/errorBoundary/context/ErrorBoundaryProvider.tsx


const ErrorBoundaryContext = /*#__PURE__*/(0,react.createContext)({
  error: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onReset: () => {}
});
const ErrorBoundaryProvider = _ref => {
  let {
    children,
    contextValue
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBoundaryContext.Provider, {
    value: contextValue,
    children: children
  });
};
;// CONCATENATED MODULE: ./src/shared/utils/errorBoundary/hooks/useError.ts


const useError = () => {
  return (0,react.useContext)(ErrorBoundaryContext);
};
// EXTERNAL MODULE: ./src/components/features/index.ts + 21 modules
var features = __webpack_require__(50436);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+styled@11.3.0_ptrnt234kjnnyquz3novyfo6d4/node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 2 modules
var emotion_styled_base_browser_esm = __webpack_require__(71897);
;// CONCATENATED MODULE: ./src/shared/utils/errorBoundary/components/styled.ts

const StyledContent = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ex5w9ty0"
} : 0)(() => ({
  width: 'fit-content',
  maxWidth: 580,
  margin: '15px auto'
}),  true ? "" : 0);
;// CONCATENATED MODULE: ./src/shared/utils/errorBoundary/components/ErrorBoundaryFallback.tsx







const ErrorBoundaryFallback = _ref => {
  let {
    description
  } = _ref;
  const {
    error
  } = useError();
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    0: dismiss,
    1: setDismiss
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    console.info(`%cuse${error === null || error === void 0 ? void 0 : error.message}`, 'color: #eed202');
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: !dismiss && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContent, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(features/* Notification */.P_, {
        onDismiss: () => setDismiss(true),
        text: description || translate('message.contentUnavailable'),
        duration: 0
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/shared/utils/errorBoundary/ErrorBoundary.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const initialState = {
  error: null
};
/**
 * Wrap a scope in error boundary to catch errors
 * @example
 * <ErrorBoundary onError={onError} onReset={onReset} fallback={Fallback}>
 *    <WithBugs />
 * </ErrorBoundary>
 *
 * onError = Evoke function on error
 * onReset = Evoke retry or try to fix function when useError onReset is executed
 * fallback = Supply fallback component, defaults to <ErrorBoundaryFallback />
 *
 * Error is available in fallback componenet with useError hook
 *
 * @example
 * const { error, onReset } = useError();
 *
 * <div>Sorry an error occurred {error.message} try again?
 * <button onClick={onReset}>
 *     Try again
 * </button>
 *
 */

class ErrorBoundary extends react.Component {
  constructor(props) {
    super(props);
    this.onReset = this.onReset.bind(this);
    this.state = initialState;
  }

  static getDerivedStateFromError(error) {
    return {
      error
    };
  }

  componentDidCatch(error, info) {
    var _this$props$onError, _this$props;

    (_this$props$onError = (_this$props = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props, error, info);
  }

  onReset() {
    var _this$props$onReset, _this$props2;

    (_this$props$onReset = (_this$props2 = this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call(_this$props2);
    this.setState(initialState);
  }

  render() {
    const {
      error
    } = this.state;

    if (error !== null) {
      const {
        fallback: Fallback = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBoundaryFallback, {})
      } = this.props;
      const contextValue = {
        error,
        onReset: this.onReset
      };
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBoundaryProvider, {
        contextValue: contextValue,
        children: typeof Fallback === 'function' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Fallback, _objectSpread({}, contextValue)) : Fallback
      });
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: this.props.children
    });
  }

}
;// CONCATENATED MODULE: ./src/shared/utils/errorBoundary/WithErrorBoundary.tsx


/**
 * HOC to wrap the export, provide a optional fallback component
 * @example
 * export default withErrorBoundary(MyComponent, <ErrorBoundaryFallback description="This content is currently not available"/>)
 */


function withErrorBoundary(WrappedComponent, FallBack) {
  return () => (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBoundary, {
    fallback: FallBack,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WrappedComponent, {})
  });
}
;// CONCATENATED MODULE: ./src/shared/utils/errorBoundary/index.ts


// EXTERNAL MODULE: ./src/components/features/Navigation/components/N10Meta/N10Meta.module.css
var N10Meta_module = __webpack_require__(6635);
var N10Meta_module_default = /*#__PURE__*/__webpack_require__.n(N10Meta_module);
// EXTERNAL MODULE: ./src/components/features/Navigation/components/N20MainMenu/components/LoginButton/LoginButton.module.css
var LoginButton_module = __webpack_require__(95932);
var LoginButton_module_default = /*#__PURE__*/__webpack_require__.n(LoginButton_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 7 modules
var hooks = __webpack_require__(79143);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N20MainMenu/components/LoginButton/LoginButton.tsx







const LoginButton = () => {
  var _staticLinks$profileP, _session$user;

  const {
    data: frameData
  } = (0,cms/* useFrame */.xQ)();
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    isAuthenticated,
    isAuthenticating,
    session
  } = (0,hooks/* useAuthentication */.JL)();
  const staticLinks = frameData === null || frameData === void 0 ? void 0 : frameData.staticLinks;

  if (!(staticLinks !== null && staticLinks !== void 0 && staticLinks.loginPage) || isAuthenticating) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
    className: (0,clsx_m/* default */.Z)((LoginButton_module_default()).buttonPadding, (LoginButton_module_default()).link),
    href: !isAuthenticated ? staticLinks === null || staticLinks === void 0 ? void 0 : staticLinks.loginPage.url : staticLinks === null || staticLinks === void 0 ? void 0 : (_staticLinks$profileP = staticLinks.profilePage) === null || _staticLinks$profileP === void 0 ? void 0 : _staticLinks$profileP.url,
    variant: "link",
    iconName: !isAuthenticated ? 'login' : 'user',
    "aria-label": translate('auth.login'),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      className: (0,clsx_m/* default */.Z)((LoginButton_module_default()).link, (LoginButton_module_default()).loginText),
      variant: "bodySmall",
      children: !isAuthenticated ? translate('auth.login') : session === null || session === void 0 ? void 0 : (_session$user = session.user) === null || _session$user === void 0 ? void 0 : _session$user.firstName
    })
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N20MainMenu/components/LoginButton/index.ts

;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N10Meta/N10Meta.tsx


function N10Meta_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function N10Meta_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? N10Meta_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : N10Meta_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











const N10Meta = /*#__PURE__*/(0,react.memo)(() => {
  const {
    data
  } = (0,cms/* useFrame */.xQ)();
  const {
    metaMenu
  } = (data === null || data === void 0 ? void 0 : data.navigation) || {};
  const {
    uspList
  } = (data === null || data === void 0 ? void 0 : data.usp) || {};
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    className: (N10Meta_module_default()).n10Meta,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* MaxWidth */.Pm, {
      className: (N10Meta_module_default()).content,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: (N10Meta_module_default()).innerContent,
        children: [!!(uspList !== null && uspList !== void 0 && uspList.length) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Usp, {
          uspItems: uspList
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
          className: (N10Meta_module_default()).list,
          children: [!!(metaMenu !== null && metaMenu !== void 0 && metaMenu.length) && metaMenu.map(link => link.url && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Link */.rU, N10Meta_objectSpread({
              className: (N10Meta_module_default()).link,
              href: link.url,
              children: link.title
            }, link))
          }, (0,jsx/* weakKey */.RU)({
            link
          }))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginButton, {})]
        })]
      })
    })
  });
});
/* harmony default export */ var N10Meta_N10Meta = (withErrorBoundary(N10Meta));
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N10Meta/index.ts


// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.5_zwnwwcpulpacxjlmvctaxclnzi/node_modules/next/router.js
var next_router = __webpack_require__(73648);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/animations.ts
const nonAnimatedVariants = {
  active: {
    opacity: 1
  },
  inactive: {
    opacity: 0,
    transitionEnd: {
      display: 'none'
    }
  }
};
const animatedVariants = {
  active: {
    opacity: 1,
    transition: {
      duration: 0.25,
      delay: 0.25,
      ease: 'easeOut'
    }
  },
  inactive: {
    opacity: 0,
    transition: {
      duration: 0.25,
      ease: 'easeOut'
    },
    transitionEnd: {
      display: 'none'
    }
  }
};
const variants = prefersReducedMotion => prefersReducedMotion ? nonAnimatedVariants : animatedVariants;
const animatedOverlay = {
  active: {
    opacity: 0.2,
    transition: {
      duration: 0.25,
      delay: 0.25,
      ease: 'easeOut'
    }
  },
  inactive: {
    opacity: 0,
    transition: {
      duration: 0.25,
      ease: 'easeOut'
    },
    transitionEnd: {
      display: 'none'
    }
  }
};
// EXTERNAL MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/Backdrop/Backdrop.module.css
var Backdrop_module = __webpack_require__(30327);
var Backdrop_module_default = /*#__PURE__*/__webpack_require__.n(Backdrop_module);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/Backdrop/Backdrop.tsx






/**
 * Mimics an elements height based on it's `imitator` prop
 * handles resizing
 */
const Backdrop = /*#__PURE__*/(0,react.memo)(_ref => {
  let {
    activeNodeHeight
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
    className: (0,clsx_m/* default */.Z)((Backdrop_module_default()).backdrop),
    animate: {
      height: activeNodeHeight
    },
    transition: {
      ease: [0.25, 0, 0, 1],
      duration: 0.55
    }
  });
});
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/Backdrop/index.ts

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.5_zwnwwcpulpacxjlmvctaxclnzi/node_modules/next/link.js
var next_link = __webpack_require__(65259);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/.pnpm/styled-tools@1.7.2/node_modules/styled-tools/dist/es/index.js + 4 modules
var es = __webpack_require__(71166);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/NavigationLink/styled.tsx


const StyledNavigationLink = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "eowxrgq0"
} : 0)(_ref => {
  let {
    theme: {
      colors
    }
  } = _ref;
  return {
    display: 'inline-block',
    color: colors.grey90,
    textDecoration: 'none',
    '&:hover': {
      color: colors.black,
      textDecoration: 'underline'
    }
  };
}, (0,es/* switchProp */.db)('variant', {
  header: _ref2 => {
    let {
      theme
    } = _ref2;
    return {
      fontSize: `${theme.fontSizes.xl}`,
      fontWeight: theme.fontWeights.bold,
      marginBottom: theme.spaces[6]
    };
  },
  subHeader: _ref3 => {
    let {
      theme
    } = _ref3;
    return {
      fontSize: `${theme.fontSizes.sm}`,
      fontWeight: theme.fontWeights.bold,
      marginBottom: theme.spaces[4]
    };
  },
  link: _ref4 => {
    let {
      theme
    } = _ref4;
    return {
      fontSize: `${theme.fontSizes['2xs']}`,
      marginBottom: theme.spaces[2]
    };
  }
}),  true ? "" : 0);
// EXTERNAL MODULE: ./src/tracking/GTM/index.ts + 8 modules
var GTM = __webpack_require__(35217);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/NavigationLink/NavigationLink.tsx







/**
 * Navigation link with varieties.
 *
 */
const NavigationLink = /*#__PURE__*/(0,react.memo)(_ref => {
  let {
    link,
    variant = 'link',
    nodeIndex
  } = _ref;

  if (!(link !== null && link !== void 0 && link.url)) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
    href: link.url,
    passHref: true,
    prefetch: false,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledNavigationLink, {
      target: link.target,
      title: link.title,
      variant: variant,
      children: link.title,
      onClick: () => {
        if (nodeIndex) (0,GTM/* trackMenuClick */.Kr)(nodeIndex, link.title ?? '');
      }
    })
  });
});
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/NavigationLink/index.ts

// EXTERNAL MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/Menu/Menu.module.css
var Menu_module = __webpack_require__(9745);
var Menu_module_default = /*#__PURE__*/__webpack_require__.n(Menu_module);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/Menu/Menu.tsx







const Menu = /*#__PURE__*/(0,react.memo)(_ref => {
  let {
    nodes
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    className: (0,clsx_m/* default */.Z)((Menu_module_default()).menuWrapper),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (0,clsx_m/* default */.Z)((Menu_module_default()).menu),
      children: nodes === null || nodes === void 0 ? void 0 : nodes.map(subNode => {
        var _subNode$children;

        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationLink, {
            link: subNode.link,
            variant: "subHeader",
            nodeIndex: 2
          }), (_subNode$children = subNode.children) === null || _subNode$children === void 0 ? void 0 : _subNode$children.map((_ref2, index) => {
            let {
              link
            } = _ref2;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationLink, {
                link: link,
                nodeIndex: 3
              })
            }, index);
          })]
        }, (0,jsx/* weakKey */.RU)(subNode));
      })
    })
  });
});
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/Menu/index.ts

// EXTERNAL MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/NavigationItem/NavigationItem.module.css
var NavigationItem_module = __webpack_require__(93345);
var NavigationItem_module_default = /*#__PURE__*/__webpack_require__.n(NavigationItem_module);
// EXTERNAL MODULE: ./src/tracking/GTM/functions/trackMenuClick.ts
var trackMenuClick = __webpack_require__(36381);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/NavigationItem/NavigationItem.tsx










/**
 * Navigation item, which will render either as a link or button, based on it's childnodes presence.
 * has a active and inactive state.
 */
const NavigationItem = /*#__PURE__*/(0,react.memo)(props => {
  const {
    link,
    subNodes,
    onClick,
    privateLink
  } = props;

  if (subNodes !== null && subNodes !== void 0 && subNodes.length) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
      className: (0,clsx_m/* default */.Z)((NavigationItem_module_default()).navigationItem, {
        [(NavigationItem_module_default()).active]: props.active,
        [(NavigationItem_module_default()).privateLink]: privateLink
      }),
      onClick: () => {
        if (link !== null && link !== void 0 && link.title) {
          (0,trackMenuClick/* trackMenuClick */.K)(1, link.title);
        }

        onClick === null || onClick === void 0 ? void 0 : onClick();
      },
      "aria-expanded": props.active,
      children: [link === null || link === void 0 ? void 0 : link.title, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* SvgIcon */.le, {
        name: props.active ? 'chevron-up' : 'chevron-down'
      })]
    });
  }

  if (link !== null && link !== void 0 && link.url) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      prefetch: false,
      href: link.url,
      passHref: true,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        className: (0,clsx_m/* default */.Z)((NavigationItem_module_default()).navigationItem, {
          [(NavigationItem_module_default()).active]: props.active,
          [(NavigationItem_module_default()).privateLink]: privateLink
        }),
        children: link.title,
        title: link.title,
        target: link.target,
        onClick: () => {
          if (link.title) {
            (0,trackMenuClick/* trackMenuClick */.K)(1, link.title);
          }
        }
      })
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
});
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/NavigationItem/index.ts

// EXTERNAL MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/PromotedChildren/PromotedChildren.module.css
var PromotedChildren_module = __webpack_require__(93628);
var PromotedChildren_module_default = /*#__PURE__*/__webpack_require__.n(PromotedChildren_module);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/PromotedChildren/PromotedChildren.tsx


function PromotedChildren_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PromotedChildren_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PromotedChildren_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PromotedChildren_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






/**
 * A list of link images, with optional texts
 */



const PromotedChildren = /*#__PURE__*/(0,react.memo)(_ref => {
  let {
    nodes
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    className: (0,clsx_m/* default */.Z)((PromotedChildren_module_default()).promotedContent),
    children: nodes === null || nodes === void 0 ? void 0 : nodes.map((_ref2, i) => {
      let {
        image,
        link
      } = _ref2;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: (0,clsx_m/* default */.Z)((PromotedChildren_module_default()).promotedItem),
        children: [(image === null || image === void 0 ? void 0 : image.src) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Image */.Ee, PromotedChildren_objectSpread(PromotedChildren_objectSpread({}, image), {}, {
          width: 384,
          height: 251,
          sizes: "300px",
          objectFit: "cover"
        })), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: (0,clsx_m/* default */.Z)((PromotedChildren_module_default()).itemOverlay),
          children: [link.title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            className: (0,clsx_m/* default */.Z)((PromotedChildren_module_default()).info),
            variant: "body",
            children: link.title
          }), (link === null || link === void 0 ? void 0 : link.url) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: link.url,
            passHref: true,
            prefetch: false,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* LinkDeprecated */.cA, PromotedChildren_objectSpread(PromotedChildren_objectSpread({
              className: (PromotedChildren_module_default()).coverLink,
              href: link.url
            }, link), {}, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* VisuallyHidden */.TX, {
                children: link.title
              })
            }))
          })]
        })]
      }, i);
    })
  });
});
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/PromotedChildren/index.ts

;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/components/index.ts





// EXTERNAL MODULE: ../../node_modules/.pnpm/framer-motion@7.6.19_biqbaboplfbrettd7655fr4n2y/node_modules/framer-motion/dist/es/utils/reduced-motion/use-reduced-motion.mjs
var use_reduced_motion = __webpack_require__(60266);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-use@17.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/react-use/esm/useEffectOnce.js
var useEffectOnce = __webpack_require__(78257);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-use@17.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/react-use/esm/useUnmount.js


var useUnmount = function (fn) {
    var fnRef = (0,react.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    (0,useEffectOnce/* default */.Z)(function () { return function () { return fnRef.current(); }; });
};
/* harmony default export */ var esm_useUnmount = (useUnmount);

;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-use@17.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/react-use/esm/useRafState.js


var useRafState = function (initialState) {
    var frame = (0,react.useRef)(0);
    var _a = (0,react.useState)(initialState), state = _a[0], setState = _a[1];
    var setRafState = (0,react.useCallback)(function (value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function () {
            setState(value);
        });
    }, []);
    esm_useUnmount(function () {
        cancelAnimationFrame(frame.current);
    });
    return [state, setRafState];
};
/* harmony default export */ var esm_useRafState = (useRafState);

// EXTERNAL MODULE: ../../node_modules/.pnpm/react-use@17.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/react-use/esm/misc/util.js
var util = __webpack_require__(88390);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/react-use@17.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/react-use/esm/useWindowSize.js



var useWindowSize = function (initialWidth, initialHeight) {
    if (initialWidth === void 0) { initialWidth = Infinity; }
    if (initialHeight === void 0) { initialHeight = Infinity; }
    var _a = esm_useRafState({
        width: util/* isBrowser */.jU ? window.innerWidth : initialWidth,
        height: util/* isBrowser */.jU ? window.innerHeight : initialHeight,
    }), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        if (util/* isBrowser */.jU) {
            var handler_1 = function () {
                setState({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            };
            (0,util.on)(window, 'resize', handler_1);
            return function () {
                (0,util/* off */.S1)(window, 'resize', handler_1);
            };
        }
    }, []);
    return state;
};
/* harmony default export */ var esm_useWindowSize = (useWindowSize);

// EXTERNAL MODULE: ../../node_modules/.pnpm/react-use@17.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/react-use/esm/useDebounce.js
var useDebounce = __webpack_require__(38457);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-use@17.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/react-use/esm/useClickAway.js
var useClickAway = __webpack_require__(40306);
// EXTERNAL MODULE: ./src/components/features/Navigation/components/N30MegaMenu/N30MegaMenu.module.css
var N30MegaMenu_module = __webpack_require__(70046);
var N30MegaMenu_module_default = /*#__PURE__*/__webpack_require__.n(N30MegaMenu_module);
// EXTERNAL MODULE: ./src/constants/index.ts + 1 modules
var constants = __webpack_require__(48564);
// EXTERNAL MODULE: ../../packages/utils/dist/index.mjs
var dist = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/N30MegaMenu.tsx


















/**
 * A basic navigation with related mega menu.
 * covers basic SEO and accessibility needs.
 * Handles active/inactive state and close on route change.
 */
const N30MegaMenu = /*#__PURE__*/(0,react.memo)(_ref => {
  let {
    navigation
  } = _ref;
  const {
    0: activeIndex,
    1: setActiveIndex
  } = (0,react.useState)(null);
  const {
    0: activeNode,
    1: setActiveNode
  } = (0,react.useState)(null);
  const navigationRef = (0,react.useRef)(null);
  const {
    asPath
  } = (0,next_router.useRouter)();
  const shouldReduceMotion = (0,use_reduced_motion/* useReducedMotion */.J)();
  const {
    lock,
    unlock,
    isLocked
  } = (0,dist.useScrollLock)();
  const {
    width,
    height
  } = esm_useWindowSize();
  const {
    0: activeNodeHeight,
    1: setActiveNodeHeight
  } = (0,react.useState)(0);
  const {
    session
  } = (0,hooks/* useAuthentication */.JL)();
  (0,react.useEffect)(() => {
    if (height > ((activeNode === null || activeNode === void 0 ? void 0 : activeNode.offsetHeight) ?? 0) + 113) {
      setActiveNodeHeight((activeNode === null || activeNode === void 0 ? void 0 : activeNode.offsetHeight) ?? 0);
    } else {
      setActiveNodeHeight(height - 200);
    }
  }, [activeNode, height]);
  (0,useDebounce/* default */.Z)(() => {
    if (height > ((activeNode === null || activeNode === void 0 ? void 0 : activeNode.offsetHeight) ?? 0) + 113) {
      setActiveNodeHeight((activeNode === null || activeNode === void 0 ? void 0 : activeNode.offsetHeight) ?? 0);
    } else {
      setActiveNodeHeight(height - 200);
    }
  }, 50, [width, height]);
  (0,useClickAway/* default */.Z)(navigationRef, () => {
    setActiveIndex(null);

    if (isLocked) {
      unlock();
    }
  });
  (0,react.useEffect)(() => {
    setActiveIndex(null);
    unlock();
  }, [asPath]);
  const measuredRef = (0,react.useCallback)(node => {
    setActiveNode(node);
  }, []);
  const keyMap = (0,react.useCallback)(key => {
    var _key, _ref2;

    return (_key = (_ref2 = {
      Escape: () => setActiveIndex(null)
    })[key]) === null || _key === void 0 ? void 0 : _key.call(_ref2);
  }, []);
  const clickedNagivationItem = (0,react.useCallback)((isActive, index) => {
    if (isActive) {
      setActiveIndex(null);
      unlock();
    } else {
      setActiveIndex(index);
      lock();
    }
  }, [lock, activeIndex]);
  const styledContentMaxWidth = {
    "--content-max-width": `${constants/* sizes.contentMaxWidth */.J.contentMaxWidth}px`
  };
  return (// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("nav", {
      onKeyDown: _ref3 => {
        let {
          key
        } = _ref3;
        return keyMap(key);
      },
      ref: navigationRef,
      children: [!shouldReduceMotion && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
          className: (0,clsx_m/* default */.Z)((N30MegaMenu_module_default()).dropDownOverlay),
          variants: animatedOverlay,
          style: {
            display: activeIndex && activeNodeHeight > 0 ? 'block' : 'none'
          },
          animate: activeIndex && activeNodeHeight > 0 ? 'active' : 'inactive',
          initial: "inactive"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Backdrop, {
          activeNodeHeight: activeNodeHeight
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
        className: (0,clsx_m/* default */.Z)((N30MegaMenu_module_default()).list),
        children: navigation === null || navigation === void 0 ? void 0 : navigation.map((_ref4, index) => {
          let {
            children,
            promotedChildren,
            link,
            isLoginHidden
          } = _ref4;
          const isActive = index === activeIndex;

          if (isLoginHidden === true && !(session !== null && session !== void 0 && session.accessToken)) {
            return null;
          }

          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationItem, {
              active: isActive || asPath === (link === null || link === void 0 ? void 0 : link.url),
              onClick: () => clickedNagivationItem(isActive, index),
              subNodes: children,
              link: link,
              privateLink: isLoginHidden,
              nodeIndex: 1
            }), !!(children !== null && children !== void 0 && children.length) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
              className: (0,clsx_m/* default */.Z)((N30MegaMenu_module_default()).dropDown),
              variants: variants(shouldReduceMotion),
              style: {
                display: isActive ? 'block' : undefined,
                maxHeight: activeNodeHeight
              },
              animate: isActive ? 'active' : 'inactive',
              initial: "inactive",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Gutter */.Th, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                  ref: isActive ? measuredRef : undefined,
                  className: (0,clsx_m/* default */.Z)((N30MegaMenu_module_default()).dropDownMaxWidth),
                  style: styledContentMaxWidth,
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationLink, {
                    link: link,
                    variant: "header"
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: (0,clsx_m/* default */.Z)((N30MegaMenu_module_default()).dropDownContent),
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, {
                      nodes: children
                    }), !!(promotedChildren !== null && promotedChildren !== void 0 && promotedChildren.length) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PromotedChildren, {
                      nodes: promotedChildren
                    })]
                  })]
                })
              })
            })]
          }, index);
        })
      })]
    })
  );
});
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N30MegaMenu/index.ts

// EXTERNAL MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/Drawer/Drawer.module.css
var Drawer_module = __webpack_require__(14813);
var Drawer_module_default = /*#__PURE__*/__webpack_require__.n(Drawer_module);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/Drawer/Drawer.tsx





const Drawer = /*#__PURE__*/(0,react.memo)(_ref => {
  let {
    children,
    open,
    onClose
  } = _ref;
  const drawerContainerRef = (0,react.useRef)(null);
  const {
    0: isVisible,
    1: setIsVisible
  } = (0,react.useState)(open);
  const offset = (0,react.useMemo)(() => {
    if (drawerContainerRef.current) {
      return drawerContainerRef.current.getBoundingClientRect().top - 1;
    }

    return 0;
  }, [open]);

  const onKeyDownHandler = event => {
    if (event.key === 'Escape') {
      onClose === null || onClose === void 0 ? void 0 : onClose();
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (0,clsx_m/* default */.Z)((Drawer_module_default()).drawerContainer, {
      [(Drawer_module_default()).open]: open
    }),
    onKeyDown: onKeyDownHandler,
    ref: drawerContainerRef,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (0,clsx_m/* default */.Z)((Drawer_module_default()).drawer, {
        [(Drawer_module_default()).open]: open
      }),
      onAnimationEnd: () => setIsVisible(open),
      style: {
        display: open || isVisible ? '' : 'none',
        top: offset ? `${offset}px` : 0
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,clsx_m/* default */.Z)((Drawer_module_default()).content),
        children: children
      })
    }), open && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (0,clsx_m/* default */.Z)((Drawer_module_default()).backdrop, (Drawer_module_default()).open),
      onClick: onClose
    })]
  });
});
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/Drawer/index.ts

// EXTERNAL MODULE: ../../node_modules/.pnpm/framer-motion@7.6.19_biqbaboplfbrettd7655fr4n2y/node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(50766);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/MobileMegaMenu/animations.ts
const animationDirections = {
  backwards: {
    initial: {
      opacity: 0,
      x: -25
    },
    exit: {
      opacity: 0,
      x: 25
    }
  },
  forwards: {
    initial: {
      opacity: 0,
      x: 25
    },
    exit: {
      opacity: 0,
      x: -25
    }
  }
};
const animationVariations = {
  exit: direction => animationDirections[direction].exit,
  initial: direction => animationDirections[direction].initial,
  animate: {
    opacity: 1,
    x: 0
  }
};
// EXTERNAL MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/NodeItem/NodeItem.module.css
var NodeItem_module = __webpack_require__(78530);
var NodeItem_module_default = /*#__PURE__*/__webpack_require__.n(NodeItem_module);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/NodeItem/NodeItem.tsx







const NodeItem = _ref => {
  let {
    node,
    onSelectNode
  } = _ref;
  const {
    children,
    link,
    isLoginHidden
  } = node;
  const asButton = !!(children !== null && children !== void 0 && children.length);

  const onClickHandler = () => {
    if (link !== null && link !== void 0 && link.title) {
      (0,trackMenuClick/* trackMenuClick */.K)(1, link.title);
    }

    onSelectNode === null || onSelectNode === void 0 ? void 0 : onSelectNode(node);
  };

  if (asButton) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
      variant: "link",
      iconName: "chevron-right",
      iconPosition: "right",
      className: (NodeItem_module_default()).nodeButton,
      onClick: onClickHandler,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,clsx_m/* default */.Z)((NodeItem_module_default()).content, {
          [(NodeItem_module_default()).loginHidden]: isLoginHidden
        }),
        children: link === null || link === void 0 ? void 0 : link.title
      })
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
    href: link === null || link === void 0 ? void 0 : link.url,
    passHref: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
      variant: "link",
      target: link.target,
      className: (NodeItem_module_default()).nodeLink,
      onClick: onClickHandler,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,clsx_m/* default */.Z)((NodeItem_module_default()).content, {
          [(NodeItem_module_default()).loginHidden]: isLoginHidden
        }),
        children: link === null || link === void 0 ? void 0 : link.title
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/NodeItem/index.ts

// EXTERNAL MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/NodeList/NodeList.module.css
var NodeList_module = __webpack_require__(52508);
var NodeList_module_default = /*#__PURE__*/__webpack_require__.n(NodeList_module);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/NodeList/NodeList.tsx






const NodeList = _ref => {
  let {
    nodes,
    onSelectNode
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
    style: {
      paddingLeft: 0
    },
    children: nodes === null || nodes === void 0 ? void 0 : nodes.map(node => (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
      className: (0,clsx_m/* default */.Z)((NodeList_module_default()).listItem),
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NodeItem, {
        node: node,
        onSelectNode: onSelectNode
      })
    }, (0,jsx/* weakKey */.RU)(node)))
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/NodeList/index.ts

// EXTERNAL MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/MenuPage/MenuPage.module.css
var MenuPage_module = __webpack_require__(2309);
var MenuPage_module_default = /*#__PURE__*/__webpack_require__.n(MenuPage_module);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/MenuPage/MenuPage.tsx








const MenuPage = _ref => {
  let {
    nodes,
    headlineText,
    headlineLinkUrl,
    backText,
    onSelectNode,
    onGoBack
  } = _ref;
  const ref = (0,react.useRef)(null);
  const translate = (0,cms/* useTranslations */.T_)();
  /**
   * Focus first link on open
   */

  (0,react.useEffect)(() => {
    const element = ref.current;

    if (element) {
      const firstFocusableElement = element.querySelector('a, button');
      firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus();
    }
  }, [nodes]);
  /**
   * Support keyboard navigation up and down within the navigation
   */

  const onKeyDownHandler = event => {
    var _ref$current;

    if (!ref.current) {
      return;
    }

    const activeElement = document.activeElement;
    const focusableElements = ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelectorAll('a, button')) || [];
    const currentFocusIndex = Array.from(focusableElements).indexOf(activeElement);

    if (event.key === 'ArrowDown') {
      var _focusableElements$fo;

      const focusIndex = Math.min(currentFocusIndex + 1, focusableElements.length - 1);
      (_focusableElements$fo = focusableElements[focusIndex]) === null || _focusableElements$fo === void 0 ? void 0 : _focusableElements$fo.focus();
      event.preventDefault();
    } else if (event.key === 'ArrowUp') {
      var _focusableElements$fo2;

      const focusIndex = Math.max(currentFocusIndex - 1, 0);
      (_focusableElements$fo2 = focusableElements[focusIndex]) === null || _focusableElements$fo2 === void 0 ? void 0 : _focusableElements$fo2.focus();
      event.preventDefault();
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (MenuPage_module_default()).menuPage,
    ref: ref,
    onKeyDown: onKeyDownHandler,
    children: [headlineText && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: (MenuPage_module_default()).header,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (MenuPage_module_default()).backContainer,
        children: backText && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
          variant: "link",
          iconName: "chevron-left",
          onClick: onGoBack,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
            children: [translate('navigation.mobile.mainMenu.goBackTo'), ' ', backText.toLocaleLowerCase()]
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "bodyLarge",
        as: "b",
        children: headlineText
      }), headlineLinkUrl && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: headlineLinkUrl,
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Link */.rU, {
          href: headlineLinkUrl,
          children: translate('navigation.mobile.mainMenu.viewAll')
        })
      })]
    }), nodes !== null && nodes !== void 0 && nodes.length ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NodeList, {
      nodes: nodes,
      onSelectNode: onSelectNode
    }) : null]
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/MenuPage/index.ts

;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/utils/lookupNodeById.tsx
function lookupNodeById(nodeId) {
  let haystack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!nodeId) return undefined;

  for (let i = 0; i < haystack.length; i++) {
    const node = haystack[i];
    const {
      children = []
    } = node; // Check if current node is parent

    if (node.link.id === nodeId) {
      return node;
    } else if (children !== null && children !== void 0 && children.length) {
      // Check if parent in children
      const node = lookupNodeById(nodeId, children);

      if (node) {
        return node;
      }
    }
  }
}
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/utils/lookupNodeByUrl.tsx
function lookupNodeByUrl(url) {
  let haystack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!url) return undefined;

  for (let i = 0; i < haystack.length; i++) {
    const node = haystack[i];
    const {
      children = [],
      link
    } = node; // Check if current node is parent

    if ((link === null || link === void 0 ? void 0 : link.url) === url) {
      return node;
    } else if (children !== null && children !== void 0 && children.length) {
      // Check if parent in children
      const node = lookupNodeByUrl(url, children);

      if (node) {
        return node;
      }
    }
  }
}
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/utils/lookupParentNode.tsx
function lookupParentNode(needle, haystack) {
  if (!needle) return needle;

  for (let i = 0; i < haystack.length; i++) {
    const node = haystack[i];
    const {
      children = []
    } = node; // Check if current node is parent

    if (children !== null && children !== void 0 && children.includes(needle)) {
      return node;
    } else if (children !== null && children !== void 0 && children.length) {
      // Check if parent in children
      const parent = lookupParentNode(needle, children);

      if (parent) {
        return parent;
      }
    }
  }
}
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/MobileMegaMenu/MobileMegaMenu.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














const StyledWrapper = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eiot2rs0"
} : 0)( true ? {
  name: "1pbmicl",
  styles: "overflow:auto;flex:1"
} : 0);

const MobileMegaMenu = _ref => {
  var _node$link, _node$link2, _parentNode$link;

  let {
    menu,
    activeNodeId,
    activeNodeByUrl
  } = _ref;
  const {
    asPath
  } = (0,next_router.useRouter)();
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    session
  } = (0,hooks/* useAuthentication */.JL)();
  const {
    0: animationDirection,
    1: setAnimationDirection
  } = (0,react.useState)('forwards');
  const {
    0: activeMenuState,
    1: setActiveMenuState
  } = (0,react.useState)(() => {
    let node;

    if (activeNodeId) {
      node = lookupNodeById(activeNodeId, menu);
    } else if (activeNodeByUrl) {
      node = lookupNodeByUrl(asPath, menu);
    }

    return node ? {
      node,
      parentNode: lookupParentNode(node, menu)
    } : {};
  });

  const onGoBackHandler = () => {
    onSelectNodeHandler(activeMenuState.parentNode);
    setAnimationDirection('backwards');
  };

  const onSelectNodeHandler = node => {
    if (node) {
      const parentNode = lookupParentNode(node, menu);
      setActiveMenuState({
        node,
        parentNode
      });
      setAnimationDirection('forwards');
    } else {
      // Go back to main menu
      setActiveMenuState({});
      setAnimationDirection('backwards');
    }
  };

  const {
    node,
    parentNode
  } = activeMenuState || {};
  const mainMenuName = translate('navigation.mobile.mainMenu.name');

  if (!(session !== null && session !== void 0 && session.accessToken) && (node === null || node === void 0 ? void 0 : node.isLoginHidden) === true) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledWrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
      mode: "wait",
      initial: false,
      custom: animationDirection,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(motion/* motion.div */.E.div, {
        variants: animationVariations,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        custom: animationDirection,
        transition: {
          type: 'tween',
          duration: 0.15,
          ease: [0.35, 0, 0.15, 1]
        },
        children: [!node && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuPage, {
          nodes: menu,
          headlineText: mainMenuName,
          onSelectNode: onSelectNodeHandler
        }), node && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuPage, {
          nodes: node.children || [],
          headlineText: (_node$link = node.link) === null || _node$link === void 0 ? void 0 : _node$link.title,
          headlineLinkUrl: (_node$link2 = node.link) === null || _node$link2 === void 0 ? void 0 : _node$link2.url,
          backText: (parentNode === null || parentNode === void 0 ? void 0 : (_parentNode$link = parentNode.link) === null || _parentNode$link === void 0 ? void 0 : _parentNode$link.title) || mainMenuName,
          onGoBack: onGoBackHandler,
          onSelectNode: onSelectNodeHandler
        })]
      }, (node === null || node === void 0 ? void 0 : node.link.url) || 'main')
    })
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/MobileMegaMenu/index.ts

// EXTERNAL MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/hooks/useMobileMenuState.ts
var useMobileMenuState = __webpack_require__(53372);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/hooks/useMobileMenu.ts




/**
 * Use to open and close the mobile menu.
 * It ensures a scroll lock when open.
 */

const useMobileMenu = () => {
  const forceClose = (0,useMedia/* default */.Z)('(min-width: 768px)', false);
  const {
    isOpen,
    setIsOpen
  } = (0,useMobileMenuState/* useMobileMenuState */.E)();
  const {
    lock,
    unlock
  } = (0,dist.useScrollLock)();
  const open = (0,react.useCallback)(() => {
    setIsOpen(true);
    lock();
  }, [lock, setIsOpen]);
  const close = (0,react.useCallback)(() => {
    setIsOpen(false);
    unlock();
  }, [setIsOpen, unlock]);
  const toggle = (0,react.useCallback)(() => {
    isOpen ? close() : open();
  }, [isOpen, close, open]);
  /**
   * Close in case the user breaks out of mobile
   * breakpoint - while open.
   */

  (0,react.useEffect)(() => {
    forceClose && close();
  }, [forceClose, close]);
  return {
    isOpen,
    open,
    close,
    toggle
  };
};
// EXTERNAL MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/MobileMetaMenu/MobileMetaMenu.module.css
var MobileMetaMenu_module = __webpack_require__(33011);
var MobileMetaMenu_module_default = /*#__PURE__*/__webpack_require__.n(MobileMetaMenu_module);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/MobileMetaMenu/MobileMetaMenu.tsx







const MobileMetaMenu = _ref => {
  let {
    menu
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
    className: (0,clsx_m/* default */.Z)((MobileMetaMenu_module_default()).list),
    children: menu.map(link => link.url && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: link.url,
        passHref: true,
        prefetch: false,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Link */.rU, {
          className: (0,clsx_m/* default */.Z)((MobileMetaMenu_module_default()).link),
          children: link.title,
          title: link.title,
          target: link.target
        })
      })
    }, (0,jsx/* weakKey */.RU)(link)))
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/components/MobileMetaMenu/index.ts

;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/N35MobileMegaMenu.tsx










/**
 * Mega menu for mobile. This menu renders each step as an menu page.
 */
const N35MobileMegaMenu = _ref => {
  let {
    activeNodeId,
    activeNodeByUrl = true
  } = _ref;
  const {
    isOpen,
    close
  } = useMobileMenu();
  const {
    data
  } = (0,cms/* useFrame */.xQ)();
  const {
    mainMenu = [],
    metaMenu = []
  } = (data === null || data === void 0 ? void 0 : data.navigation) || {};
  const {
    events
  } = (0,next_router.useRouter)();
  (0,react.useEffect)(() => {
    events.on('routeChangeStart', close);
    return () => events.off('routeChangeStart', close);
  }, [events, close]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Drawer, {
    open: isOpen,
    onClose: () => close(),
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMegaMenu, {
      menu: mainMenu,
      activeNodeByUrl: activeNodeByUrl,
      activeNodeId: activeNodeId
    }), !!(metaMenu !== null && metaMenu !== void 0 && metaMenu.length) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMetaMenu, {
      menu: metaMenu
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N35MobileMegaMenu/index.ts

;// CONCATENATED MODULE: ./src/components/features/Navigation/index.ts


// EXTERNAL MODULE: ./src/components/features/Navigation/components/N20MainMenu/components/FavoriteButton/FavoriteButton.module.css
var FavoriteButton_module = __webpack_require__(91083);
var FavoriteButton_module_default = /*#__PURE__*/__webpack_require__.n(FavoriteButton_module);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N20MainMenu/components/FavoriteButton/FavoriteButton.tsx








const FavoriteButton = () => {
  var _staticLinks$favorite;

  const {
    isAuthenticated
  } = (0,hooks/* useAuthentication */.JL)();
  const {
    data: frameData
  } = (0,cms/* useFrame */.xQ)();
  const staticLinks = frameData === null || frameData === void 0 ? void 0 : frameData.staticLinks;
  const {
    push
  } = (0,next_router.useRouter)();
  if (!isAuthenticated) return null;
  if (!(staticLinks !== null && staticLinks !== void 0 && (_staticLinks$favorite = staticLinks.favoritesPage) !== null && _staticLinks$favorite !== void 0 && _staticLinks$favorite.url)) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
    onClick: () => {
      var _staticLinks$favorite2;

      return push((staticLinks === null || staticLinks === void 0 ? void 0 : (_staticLinks$favorite2 = staticLinks.favoritesPage) === null || _staticLinks$favorite2 === void 0 ? void 0 : _staticLinks$favorite2.url) || '');
    },
    className: (0,clsx_m/* default */.Z)((FavoriteButton_module_default()).buttonPadding),
    variant: "link",
    iconName: "star"
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N20MainMenu/components/FavoriteButton/index.ts

// EXTERNAL MODULE: ./src/components/features/Navigation/components/N20MainMenu/components/MobileMenuButton/MobileMenuButton.module.css
var MobileMenuButton_module = __webpack_require__(22665);
var MobileMenuButton_module_default = /*#__PURE__*/__webpack_require__.n(MobileMenuButton_module);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N20MainMenu/components/MobileMenuButton/MobileMenuButton.tsx








const MobileMenuButton = () => {
  const {
    isOpen,
    toggle
  } = useMobileMenu();
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    lock,
    unlock
  } = (0,dist.useScrollLock)();

  const toggleMenu = () => {
    if (isOpen) {
      unlock();
    } else {
      lock();
    }

    toggle();
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
    className: (0,clsx_m/* default */.Z)((MobileMenuButton_module_default()).mobileMenuButton),
    iconName: isOpen ? 'close' : 'menu',
    variant: "link",
    onClick: toggleMenu,
    "aria-label": translate('navigation.mobile.mainMenu.name')
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N20MainMenu/components/MobileMenuButton/index.ts

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.5_zwnwwcpulpacxjlmvctaxclnzi/node_modules/next/dist/compiled/native-url/index.js
var native_url = __webpack_require__(77780);
// EXTERNAL MODULE: ./src/theme/index.ts + 6 modules
var src_theme = __webpack_require__(26802);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N25SearchBar/styled.ts



const StyledSearchButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* ButtonDeprecated */.Ev,  true ? {
  target: "emnza2b0"
} : 0)(_ref => {
  let {
    theme
  } = _ref;
  return {
    backgroundColor: theme.colors.red,
    color: theme.colors.white,
    width: theme.sizes.searchHeight,
    height: theme.sizes.searchHeight,
    position: 'absolute',
    right: 0,
    top: 0,
    ['&:hover']: {
      backgroundColor: theme.colors.red,
      ['svg path']: {
        stroke: theme.colors.black
      }
    },
    [src_theme/* breakpoints.md */.AV.md]: {
      width: `calc(${theme.sizes.searchHeight}px + 1px)`,
      height: `calc(${theme.sizes.searchHeight}px + 1px)`,
      borderTopRightRadius: '4px',
      borderBottomRightRadius: '4px'
    },
    svg: {
      width: '24px',
      height: '24px'
    }
  };
},  true ? "" : 0);
// EXTERNAL MODULE: ./src/components/features/Navigation/components/N25SearchBar/N25SearchBar.module.css
var N25SearchBar_module = __webpack_require__(73372);
var N25SearchBar_module_default = /*#__PURE__*/__webpack_require__.n(N25SearchBar_module);
// EXTERNAL MODULE: ./src/components/features/ProductsList/Facets/use-facets.ts
var use_facets = __webpack_require__(94401);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N25SearchBar/N25SearchBar.tsx


function N25SearchBar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function N25SearchBar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? N25SearchBar_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : N25SearchBar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















[];
const N25SearchBar = _ref => {
  var _frameData$staticLink, _frameData$staticLink2;

  let {
    shouldAutoHide
  } = _ref;
  const router = (0,next_router.useRouter)();
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    data: frameData
  } = (0,cms/* useFrame */.xQ)();
  const isMobile = !(0,useMedia/* default */.Z)(`(min-width: ${constants/* breakpoints.md */.A.md}px)`, false);
  const {
    0: inputValue,
    1: setInputValue
  } = (0,react.useState)('');
  let searchUrl = frameData === null || frameData === void 0 ? void 0 : (_frameData$staticLink = frameData.staticLinks) === null || _frameData$staticLink === void 0 ? void 0 : (_frameData$staticLink2 = _frameData$staticLink.searchPage) === null || _frameData$staticLink2 === void 0 ? void 0 : _frameData$staticLink2.url;
  (0,react.useEffect)(() => {
    var _frameData$staticLink3, _frameData$staticLink4;

    if (frameData !== null && frameData !== void 0 && (_frameData$staticLink3 = frameData.staticLinks) !== null && _frameData$staticLink3 !== void 0 && (_frameData$staticLink4 = _frameData$staticLink3.searchPage) !== null && _frameData$staticLink4 !== void 0 && _frameData$staticLink4.url) {
      var _frameData$staticLink5, _frameData$staticLink6;

      searchUrl = frameData === null || frameData === void 0 ? void 0 : (_frameData$staticLink5 = frameData.staticLinks) === null || _frameData$staticLink5 === void 0 ? void 0 : (_frameData$staticLink6 = _frameData$staticLink5.searchPage) === null || _frameData$staticLink6 === void 0 ? void 0 : _frameData$staticLink6.url;
    }
  }, [frameData === null || frameData === void 0 ? void 0 : frameData.staticLinks]);
  const searchInputRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    if (router.isReady) {
      var _router$query;

      const routerQuery = router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.query;

      if (routerQuery && routerQuery.length > 0) {
        setInputValue(routerQuery);
      }
    }
  }, [router.isReady]);
  (0,react.useEffect)(() => {
    if (!router.isReady) return;
    onInputChange(inputValue);
  }, [inputValue]);

  const onInputChange = inputQuery => {
    const routerParams = (0,use_facets/* getRouterQueryParamsWithoutPagination */.uB)(router.query);

    const queryParams = N25SearchBar_objectSpread(N25SearchBar_objectSpread({}, routerParams), {}, {
      'query': decodeURIComponent(inputQuery)
    });

    if (!(inputQuery !== null && inputQuery !== void 0 && inputQuery.length) && queryParams) {
      // Complete remove query param if no values left or no facetValue
      queryParams === null || queryParams === void 0 ? true : delete queryParams.query;
    }

    const url = (0,native_url.format)({
      pathname: searchUrl,
      query: queryParams
    });
    router.replace(url, url, {
      shallow: true
    });
  };

  const clickedSearchButton = () => {
    var _searchInputRef$curre;

    searchInputRef === null || searchInputRef === void 0 ? void 0 : (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : _searchInputRef$curre.focus();

    if (inputValue.length > 0) {
      setInputValue('');
    }
  };

  const handleOnFocus = () => {
    if (inputValue.length > 0) {
      // reset input value to move cursor to the end of the input
      setInputValue(inputValue);
      onInputChange(inputValue);
    } else {
      router.push(`${searchUrl}`, `${searchUrl}`);
    }
  };

  const styleSearchHeight = {
    "--search-height": `${constants/* sizes.searchHeight */.J.searchHeight}px`
  };
  const variants = {
    visible: {
      y: isMobile ? `calc(100% + ${constants/* sizes.searchHeight */.J.searchHeight}px + 2px)` : '0%'
    },
    //because of top border
    hidden: {
      y: '100%'
    }
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(motion/* motion.div */.E.div, {
    className: (0,clsx_m/* default */.Z)((N25SearchBar_module_default()).searchBox),
    style: styleSearchHeight,
    animate: shouldAutoHide ? 'hidden' : 'visible',
    variants: variants,
    initial: 'visible',
    transition: {
      duration: isMobile ? 0.5 : 0
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* InputField */.UP, {
      id: "search-input",
      ref: searchInputRef,
      value: inputValue,
      onChange: event => {
        const newValue = event.currentTarget.value;
        setInputValue(newValue); // Track search with 1000ms delay (only if user has typed something)

        if (newValue.trim().length > 0) {
          (0,GTM/* trackSearch */.U3)(newValue.trim(), 'search_bar');
        }
      },
      onFocus: handleOnFocus,
      placeholder: translate('header.search')
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSearchButton, {
      style: styleSearchHeight,
      onClick: clickedSearchButton,
      shape: "icon",
      variant: "tertiary",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* SvgIcon */.le, {
        name: (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) > 0 ? 'close' : 'search'
      }),
      description: 'Search'
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N25SearchBar/index.ts

// EXTERNAL MODULE: ./src/components/features/Navigation/components/N20MainMenu/N20MainMenu.module.css
var N20MainMenu_module = __webpack_require__(53075);
var N20MainMenu_module_default = /*#__PURE__*/__webpack_require__.n(N20MainMenu_module);
// EXTERNAL MODULE: ./src/components/features/Basket/index.ts + 10 modules
var Basket = __webpack_require__(78277);
// EXTERNAL MODULE: ./src/components/features/Navigation/components/N20MainMenu/components/BasketButton/BasketButton.module.css
var BasketButton_module = __webpack_require__(97885);
var BasketButton_module_default = /*#__PURE__*/__webpack_require__.n(BasketButton_module);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N20MainMenu/components/BasketButton/BasketButton.tsx









const BasketButton = () => {
  var _basket$lines, _staticLinks$basketPa;

  const {
    isAuthenticated
  } = (0,hooks/* useAuthentication */.JL)();
  const {
    data: basket
  } = (0,Basket/* useBasket */.Kc)();
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    data: frameData
  } = (0,cms/* useFrame */.xQ)();
  const staticLinks = frameData === null || frameData === void 0 ? void 0 : frameData.staticLinks;
  const {
    lines = []
  } = basket || {};
  const basketLineLength = (basket === null || basket === void 0 ? void 0 : (_basket$lines = basket.lines) === null || _basket$lines === void 0 ? void 0 : _basket$lines.length) || 0;
  if ((0,dist.isJPG)() && !isAuthenticated) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
    className: (0,clsx_m/* default */.Z)((BasketButton_module_default()).buttonPadding),
    variant: "link",
    href: (staticLinks === null || staticLinks === void 0 ? void 0 : (_staticLinks$basketPa = staticLinks.basketPage) === null || _staticLinks$basketPa === void 0 ? void 0 : _staticLinks$basketPa.url) || '',
    iconName: "shopping-cart",
    "aria-label": translate('navigation.mainMenu.basket'),
    children: lines !== null && lines !== void 0 && lines.length ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
      className: (0,clsx_m/* default */.Z)((BasketButton_module_default()).iconBadge),
      children: basketLineLength
    }) : null
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N20MainMenu/components/BasketButton/index.ts

;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N20MainMenu/N20MainMenu.tsx




















const THRESHOLD = 20;

const N20MainMenu = () => {
  const {
    data
  } = (0,cms/* useFrame */.xQ)();
  const {
    session
  } = (0,hooks/* useAuthentication */.JL)();
  const isJPGroup = (0,dist.isJPG)();
  const {
    data: page
  } = (0,cms/* usePage */.qt)();
  const {
    mainMenu = []
  } = (data === null || data === void 0 ? void 0 : data.navigation) || {};
  const scrollDirection = (0,hooks/* useScrollDirection */.C7)({
    threshold: THRESHOLD
  });
  const isMobile = !(0,useMedia/* default */.Z)(`(min-width: ${constants/* breakpoints.md */.A.md}px)`, false);
  const shouldHideSearch = scrollDirection === 'down' && isMobile;
  const hideGlobalSearch = (page === null || page === void 0 ? void 0 : page.disableGlobalSearch) && isMobile; // Set CSS variable for main content padding based on search visibility

  (0,react.useEffect)(() => {
    const rootStyle = document.documentElement.style;

    if (hideGlobalSearch) {
      rootStyle.setProperty('--main-top-padding', 'var(--spacing-2)');
    } else {
      rootStyle.setProperty('--main-top-padding', 'var(--spacing-7)');
    } // Set search visibility state for other components (like BasketHeader)


    const isSearchVisible = !shouldHideSearch && !hideGlobalSearch;
    rootStyle.setProperty('--search-bar-visible', isSearchVisible ? '1' : '0'); // Cleanup function to reset when component unmounts

    return () => {
      rootStyle.removeProperty('--main-top-padding');
      rootStyle.removeProperty('--search-bar-visible');
    };
  }, [hideGlobalSearch, shouldHideSearch]);
  const variants = {
    visible: {
      y: 0
    },
    hidden: {
      y: '-100%'
    }
  };
  const styleSearchHeight = {
    "--search-height": `${constants/* sizes.searchHeight */.J.searchHeight}px`
  };
  const styledHeaderHeightDesktop = {
    "--header-height-desktop": `${constants/* sizes.headerHeightDesktop */.J.headerHeightDesktop}px`
  };
  const styledContentMaxWidth = {
    "--content-max-width": `${constants/* sizes.contentMaxWidth */.J.contentMaxWidth}px`,
    "--header-height-desktop": `${constants/* sizes.headerHeightDesktop */.J.headerHeightDesktop}px`
  };
  const headerStyle = styledHeaderHeightDesktop;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("header", {
    className: (0,clsx_m/* default */.Z)((N20MainMenu_module_default()).mainNavigation),
    style: headerStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: (0,clsx_m/* default */.Z)((N20MainMenu_module_default()).content, {
        [(N20MainMenu_module_default()).loggedIn]: (session === null || session === void 0 ? void 0 : session.accessToken) && (session === null || session === void 0 ? void 0 : session.accessToken.length) > 0 || !isJPGroup
      }),
      style: styledContentMaxWidth,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,clsx_m/* default */.Z)((N20MainMenu_module_default()).logoContainer),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(features/* Logo */.TR, {
          description: "Logo - Frontpage"
        })
      }), !hideGlobalSearch && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(N25SearchBar, {
        shouldAutoHide: shouldHideSearch
      }), !hideGlobalSearch && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,clsx_m/* default */.Z)((N20MainMenu_module_default()).line),
        style: styleSearchHeight
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,clsx_m/* default */.Z)((N20MainMenu_module_default()).desktopNav),
        style: styledHeaderHeightDesktop,
        children: !isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(N30MegaMenu, {
          navigation: mainMenu
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("nav", {
        className: (0,clsx_m/* default */.Z)((N20MainMenu_module_default()).iconNav),
        children: [isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginButton, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FavoriteButton, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasketButton, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMenuButton, {})]
      })]
    }), !hideGlobalSearch && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
      className: (0,clsx_m/* default */.Z)((N20MainMenu_module_default()).searchBoxPlaceholder),
      style: styleSearchHeight,
      animate: shouldHideSearch ? 'hidden' : 'visible',
      variants: variants,
      transition: {
        duration: isMobile ? 0.5 : 0
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(N35MobileMegaMenu, {
      activeNodeByUrl: true
    })]
  });
};

/* harmony default export */ var N20MainMenu_N20MainMenu = (withErrorBoundary(N20MainMenu));
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N20MainMenu/index.ts


;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/GridItem/styled.ts

const StyledGridItem = (0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1inh3tz0"
} : 0)(_ref => {
  let {
    theme,
    area
  } = _ref;
  return {
    gridArea: area,
    display: 'grid',
    gap: theme.spaces[3],
    gridAutoRows: 'max-content'
  };
},  true ? "" : 0);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/GridItem/GridItem.tsx

const GridItem = StyledGridItem;
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/GridItem/index.ts

;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/MenuArea/styled.ts



const StyledMobileMenu = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "euw2n3l5"
} : 0)({
  display: 'grid',
  [src_theme/* breakpoints.sm */.AV.sm]: {
    display: 'none'
  }
},  true ? "" : 0);
const StyledDesktopMenu = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "euw2n3l4"
} : 0)(_ref => {
  let {
    theme
  } = _ref;
  return {
    display: 'none',
    gap: theme.spaces['4'],
    [src_theme/* breakpoints.sm */.AV.sm]: {
      display: 'grid'
    }
  };
},  true ? "" : 0);
const StyledMenuContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "euw2n3l3"
} : 0)({
  display: 'grid',
  alignItems: 'start',
  gridTemplateColumns: '1fr',
  gridTemplateRow: 'min-content',
  gridAutoRows: 'max-content',
  [src_theme/* breakpoints.sm */.AV.sm]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    rowGap: '2.5em'
  },
  [src_theme/* breakpoints.md */.AV.md]: {
    gridTemplateColumns: 'repeat(3, 1fr)'
  }
},  true ? "" : 0);
const StyledMenuGroup = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "euw2n3l2"
} : 0)({
  display: 'block',
  gridAutoFlow: 'row',
  gridTemplateColumns: 'max-content',
  [src_theme/* breakpoints.sm */.AV.sm]: {
    paddingRight: '2.5em'
  },
  [src_theme/* breakpoints.md */.AV.md]: {
    display: 'grid'
  },
  [`& + & ${src/* StyledAccordionItem */.wW}`]: {
    borderTop: 0
  }
},  true ? "" : 0);
const StyledMenuItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* LinkDeprecated */.cA,  true ? {
  target: "euw2n3l1"
} : 0)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    fontSize: theme.fontSizes.xs,
    textDecoration: 'none',
    [src_theme/* breakpoints.xs */.AV.xs]: {
      textDecoration: 'underline'
    }
  };
},  true ? "" : 0);
const StyledMenuItems = (0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "euw2n3l0"
} : 0)(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    display: 'grid',
    gap: theme.spaces['4']
  };
},  true ? "" : 0);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/MenuArea/components/MenuItem.tsx







const MenuItem = /*#__PURE__*/(0,react.memo)(_ref => {
  let {
    menuItem
  } = _ref;
  const {
    link,
    children
  } = menuItem;
  const validChildren = children ? children.filter(node => node.link.url) : [];

  const header = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
    variant: "display6",
    as: "p",
    fontWeight: "bold",
    role: "heading",
    children: link.title
  });

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledMenuGroup, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledMobileMenu, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* AccordionItem */.Qd, {
        header: header,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledMenuItems, {
          children: validChildren.map(_ref2 => {
            let {
              link
            } = _ref2;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: link.url,
                passHref: true,
                prefetch: false,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledMenuItem, {
                  target: link.target,
                  title: link.title,
                  children: link.title
                })
              })
            }, (0,jsx/* weakKey */.RU)(link));
          })
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledDesktopMenu, {
      children: [header, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledMenuItems, {
        children: validChildren.map(_ref3 => {
          let {
            link
          } = _ref3;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
              href: link.url,
              passHref: true,
              prefetch: false,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledMenuItem, {
                target: link.target,
                title: link.title,
                children: link.title
              })
            })
          }, (0,jsx/* weakKey */.RU)(link));
        })
      })]
    })]
  });
});
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/MenuArea/MenuArea.tsx







const MenuArea = _ref => {
  let {
    menu
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridItem, {
    area: "menu",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Accordion */.UQ, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledMenuContainer, {
        children: menu === null || menu === void 0 ? void 0 : menu.map(menuItem => (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
          menuItem: menuItem
        }, (0,jsx/* weakKey */.RU)(menuItem)))
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/MenuArea/index.ts

;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/MetaArea/styled.ts


const StyledImageContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1oyafbp1"
} : 0)(_ref => {
  let {
    theme
  } = _ref;
  return {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: theme.spaces[2],
    [src_theme/* breakpoints.sm */.AV.sm]: {
      gap: theme.spaces[3]
    },
    img: {
      maxWidth: 35,
      [src_theme/* breakpoints.sm */.AV.sm]: {
        maxWidth: 45
      }
    }
  };
},  true ? "" : 0);
const StyledMeta = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1oyafbp0"
} : 0)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    display: 'grid',
    gap: theme.spaces[6],
    gridTemplateColumns: 'auto auto',
    justifyContent: 'space-between',
    borderTop: `1px solid ${theme.colors.grey40}`,
    marginTop: theme.spaces[9],
    paddingTop: theme.spaces[4],
    paddingBottom: theme.spaces[4]
  };
},  true ? "" : 0);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/MetaArea/components/Icons.tsx




const Icons = _ref => {
  let {
    icons
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImageContainer, {
    children: icons.map((_ref2, index) => {
      let {
        image,
        title
      } = _ref2;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Image */.Ee, {
        src: image.src,
        title: title,
        loading: "lazy",
        width: 35,
        height: 20,
        layout: "intrinsic",
        sizes: "45px"
      }, image.src + index);
    })
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/MetaArea/MetaArea.tsx






const MetaArea = _ref => {
  let {
    paymentIcons,
    additionalIcons
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridItem, {
    area: "meta",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledMeta, {
      children: [paymentIcons !== null && paymentIcons !== void 0 && paymentIcons.length ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icons, {
        icons: paymentIcons
      }) : null, additionalIcons !== null && additionalIcons !== void 0 && additionalIcons.length ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icons, {
        icons: additionalIcons
      }) : null]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/MetaArea/index.ts

;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/NewsletterArea/NewsletterArea.tsx






const NewsletterArea = _ref => {
  let {
    text,
    link
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridItem, {
    area: "newsletter",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [text && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* RawHtml */.j1, {
        html: text
      }), (link === null || link === void 0 ? void 0 : link.url) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: link.url,
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ButtonDeprecated */.Ev, {
          variant: "secondary",
          as: "a",
          target: link.target,
          title: link.title,
          children: link.title
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/NewsletterArea/index.ts

;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/RichTextArea/RichTextArea.tsx





const RichTextArea = _ref => {
  let {
    text,
    logoImage
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GridItem, {
    area: "richtext",
    children: [logoImage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(features/* Logo */.TR, {
      description: "Logo - Frontpage"
    }), text && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* RawHtml */.j1, {
      html: text
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/RichTextArea/index.ts

// EXTERNAL MODULE: ./src/services/globalization/index.ts + 1 modules
var globalization = __webpack_require__(33864);
// EXTERNAL MODULE: ./src/components/features/Navigation/components/N60Footer/components/MarketSelector/MarketSelector.module.css
var MarketSelector_module = __webpack_require__(43906);
var MarketSelector_module_default = /*#__PURE__*/__webpack_require__.n(MarketSelector_module);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/MarketSelector/MarketSelector.tsx










const MarketSelector = () => {
  const {
    currentMarket,
    getStoreMarket
  } = (0,globalization/* useMarkets */.i)();
  const {
    session,
    isAuthenticated
  } = (0,hooks/* useAuthentication */.JL)();
  const translate = (0,cms/* useTranslations */.T_)();
  const router = (0,next_router.useRouter)();
  const isHovw = !(0,dist.isJPG)();

  const onMarketChange = market => {
    switchToLocale(market);
  };

  const switchToLocale = (0,react.useCallback)(locale => {
    return router.push('/', '/', {
      locale
    });
  }, [router]);
  (0,react.useEffect)(() => {
    if (session !== null && session !== void 0 && session.storeKey && !isHovw && isAuthenticated) {
      const userMarket = getStoreMarket(session.storeKey);

      if (userMarket !== null && userMarket !== void 0 && userMarket.countryCode) {
        var _userMarket$languages, _router$locale;

        const userMarketDefaultLanguage = ((_userMarket$languages = userMarket.languages.find(language => language.isDefault)) === null || _userMarket$languages === void 0 ? void 0 : _userMarket$languages.languageCode) || 'da';

        if ((userMarketDefaultLanguage === null || userMarketDefaultLanguage === void 0 ? void 0 : userMarketDefaultLanguage.toLocaleLowerCase()) !== ((_router$locale = router.locale) === null || _router$locale === void 0 ? void 0 : _router$locale.toLocaleLowerCase())) {
          switchToLocale((userMarketDefaultLanguage === null || userMarketDefaultLanguage === void 0 ? void 0 : userMarketDefaultLanguage.toLocaleLowerCase()) || 'da');
        }
      }
    }
  }, [session === null || session === void 0 ? void 0 : session.storeKey, isAuthenticated]); // removes Russian from language selector dropdown

  const languageOptions = (currentMarket === null || currentMarket === void 0 ? void 0 : currentMarket.languages.filter(language => (language === null || language === void 0 ? void 0 : language.languageCode) !== 'ru').map(language => {
    return {
      label: `${language === null || language === void 0 ? void 0 : language.languageName}` || '',
      value: (language === null || language === void 0 ? void 0 : language.languageCode) || ''
    };
  })) || [];
  if (languageOptions.length === 0 || isHovw) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (MarketSelector_module_default()).marketSelector,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "label",
      className: (MarketSelector_module_default()).marketSelectorLabel,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
        children: translate('navigation.languageSelector')
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Dropdown */.Lt, {
      items: languageOptions,
      name: translate('navigation.languageSelector'),
      onChange: value => value && onMarketChange(value),
      value: router.locale
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/MarketSelector/index.ts

;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/styled.tsx


const StyledFooter = (0,emotion_styled_base_browser_esm/* default */.Z)("footer",  true ? {
  target: "ebqtt6l4"
} : 0)(_ref => {
  let {
    theme
  } = _ref;
  return {
    backgroundColor: theme.colors.grey20,
    paddingTop: theme.spaces[8],
    overflow: 'visible',
    '&:empty': {
      display: 'none'
    },
    paddingBottom: '220px',
    [src_theme/* breakpoints.sm */.AV.sm]: {
      paddingBottom: 0,
      overflow: 'hidden'
    }
  };
},  true ? "" : 0);
const StyledGrid = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebqtt6l3"
} : 0)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    display: 'grid',
    rowGap: theme.spaces[6],
    gridAutoRows: 'max-content',
    paddingBottom: theme.spaces[2],
    gridTemplateAreas: `"menu"
                        "richtext"
                        "newsletter"
                        "market"`,
    '&:empty': {
      display: 'none'
    },
    [src_theme/* breakpoints.sm */.AV.sm]: {
      justifyContent: 'space-between',
      gridTemplateColumns: '1fr 250px',
      gridTemplateAreas: `"menu market richtext"
                            "menu market newsletter"`
    },
    [src_theme/* breakpoints.md */.AV.md]: {
      gridTemplateColumns: '60% 20% 20%'
    }
  };
},  true ? "" : 0);
const StyledFooterBanner = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebqtt6l2"
} : 0)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  [src_theme/* breakpoints.xs */.AV.xs]: {
    flexDirection: 'column',
    justifyContent: 'center'
  }
},  true ? "" : 0);
const StyledSocialBanner = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebqtt6l1"
} : 0)(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    height: theme.spaces['6'],
    width: '100%',
    backgroundColor: theme.colors.black,
    [src_theme/* breakpoints.xs */.AV.xs]: {
      height: theme.spaces['10']
    }
  };
},  true ? "" : 0);
const StyledRights = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebqtt6l0"
} : 0)(_ref4 => {
  let {
    theme
  } = _ref4;
  return {
    fontSize: theme.fontSizes.sm,
    color: theme.colors.white,
    [src_theme/* breakpoints.xs */.AV.xs]: {
      height: theme.spaces['6'],
      display: 'flex',
      alignItems: 'center'
    }
  };
},  true ? "" : 0);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/SocialArea/styled.ts


const styled_StyledImageContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eqdenra1"
} : 0)(_ref => {
  let {
    theme
  } = _ref;
  return {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: theme.spaces[2],
    [src_theme/* breakpoints.sm */.AV.sm]: {
      gap: theme.spaces[3]
    },
    img: {
      maxWidth: 35,
      [src_theme/* breakpoints.sm */.AV.sm]: {
        maxWidth: 45
      }
    }
  };
},  true ? "" : 0);
const StyledIconsContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eqdenra0"
} : 0)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    display: 'flex',
    alignItems: 'center',
    height: theme.spaces['6'],
    flex: 1,
    justifyContent: 'flex-end'
  };
},  true ? "" : 0);
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/SocialArea/components/SocialIcons.tsx




const SocialIcons = _ref => {
  let {
    icons
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styled_StyledImageContainer, {
    children: icons.map((_ref2, index) => {
      let {
        image,
        link
      } = _ref2;
      if (!image) return null;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* LinkDeprecated */.cA, {
        href: link === null || link === void 0 ? void 0 : link.url,
        title: link === null || link === void 0 ? void 0 : link.title,
        target: (link === null || link === void 0 ? void 0 : link.target) || '_self',
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Image */.Ee, {
          src: `${image === null || image === void 0 ? void 0 : image.src}`,
          title: link === null || link === void 0 ? void 0 : link.title,
          loading: "lazy",
          width: 35,
          height: 20,
          layout: "intrinsic",
          sizes: "45px"
        })
      }, `${image === null || image === void 0 ? void 0 : image.src}-${index}`);
    })
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/SocialArea/SocialArea.tsx




const SocialArea = _ref => {
  let {
    socialIcons
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledIconsContainer, {
    children: socialIcons !== null && socialIcons !== void 0 && socialIcons.length ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialIcons, {
      icons: socialIcons
    }) : null
  });
};
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/components/SocialArea/index.ts

;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/N60Footer.tsx













const N60Footer = () => {
  const {
    data: frame
  } = (0,cms/* useFrame */.xQ)();
  const {
    contactText,
    logoImage,
    menu,
    newsletterText,
    newsletterLink,
    paymentIcons,
    additionalIcons,
    socialLinks,
    copyrights
  } = (frame === null || frame === void 0 ? void 0 : frame.footer) || {};
  const showMetaArea = (paymentIcons === null || paymentIcons === void 0 ? void 0 : paymentIcons.length) || (additionalIcons === null || additionalIcons === void 0 ? void 0 : additionalIcons.length);
  const showGrid = menu || contactText || logoImage || newsletterText || newsletterLink;
  const showSocialIcons = socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.length;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledFooter, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* MaxWidth */.Pm, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Gutter */.Th, {
        children: [showGrid && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledGrid, {
          children: [menu && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuArea, {
            menu: menu
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketSelector, {}), contactText || logoImage ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichTextArea, {
            text: contactText,
            logoImage: logoImage
          }) : null, newsletterLink ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterArea, {
            text: newsletterText,
            link: newsletterLink
          }) : null]
        }), showMetaArea ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MetaArea, {
          paymentIcons: paymentIcons,
          additionalIcons: additionalIcons
        }) : null]
      })
    }), showSocialIcons ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSocialBanner, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* MaxWidth */.Pm, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Gutter */.Th, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledFooterBanner, {
            children: [copyrights ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledRights, {
              children: copyrights
            }) : null, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialArea, {
              socialIcons: socialLinks
            })]
          })
        })
      })
    }) : null]
  });
};
/* harmony default export */ var N60Footer_N60Footer = (withErrorBoundary(N60Footer));
;// CONCATENATED MODULE: ./src/components/features/Navigation/components/N60Footer/index.ts


// EXTERNAL MODULE: ./src/layout/layouts/layouts.module.css
var layouts_module = __webpack_require__(78937);
var layouts_module_default = /*#__PURE__*/__webpack_require__.n(layouts_module);
// EXTERNAL MODULE: ./src/components/features/Cookiebot/hooks/useCookieConsent/useCookieConsent.ts
var useCookieConsent = __webpack_require__(37083);
;// CONCATENATED MODULE: ./src/components/features/Cookiebot/hooks/useCookieConsent/index.ts

// EXTERNAL MODULE: ./src/shared/hooks/useNotification/index.ts + 2 modules
var useNotification = __webpack_require__(76041);
;// CONCATENATED MODULE: ./src/components/features/Cookiebot/hooks/useCookieConsent/useCookieBot.ts

/**
 * Exposes methods that live on the window,can be set in globalization-queries.ts that CookieBot has added
 */

const useCookieBot = () => {
  const {
    push
  } = (0,useNotification/* useNotification */.l)();

  const showMissing = () => push({
    duration: 5000,
    text: '#CookieBot does not exist on current environment'
  });

  const renewConsent = () => {
    var _window$CookieConsent;

    if ((_window$CookieConsent = window.CookieConsent) !== null && _window$CookieConsent !== void 0 && _window$CookieConsent.renew) {
      window.CookieConsent.renew();
    } else {
      showMissing();
    }
  };

  const getConsentFor = type => {
    var _window$Cookiebot;

    return (_window$Cookiebot = window.Cookiebot) === null || _window$Cookiebot === void 0 ? void 0 : _window$Cookiebot.consent[type];
  }; // TODO may need to update later on to renew/update consent


  return {
    renewConsent,
    getConsentFor
  };
};
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.5_zwnwwcpulpacxjlmvctaxclnzi/node_modules/next/script.js
var script = __webpack_require__(86836);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/features/Cookiebot/Cookiebot.tsx






/**
 * Loads cookie consent, and reloads in the correct language if culture changes
 */
const CookieConsent = /*#__PURE__*/(0,react.memo)(() => {
  const {
    setConsent
  } = (0,useCookieConsent/* useCookieConsent */.Y)();
  const {
    getConsentFor
  } = useCookieBot();
  (0,react.useEffect)(() => {
    const handleConsentUpdate = () => {
      setConsent({
        marketing: getConsentFor('marketing'),
        necessary: getConsentFor('necessary'),
        statistics: getConsentFor('statistics'),
        preferences: getConsentFor('preferences')
      });
    };

    window.addEventListener('CookiebotOnConsentReady', handleConsentUpdate);
    return () => {
      window.removeEventListener('CookiebotOnConsentReady', handleConsentUpdate);
    };
  }, [setConsent, getConsentFor]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
    id: "Cookiebot",
    src: "https://consent.cookiebot.com/uc.js",
    "data-cbid": "f3a16c17-67da-431c-aa63-9208574b65d4",
    type: "text/javascript",
    async: true
  });
});
;// CONCATENATED MODULE: ./src/components/features/Cookiebot/index.ts


;// CONCATENATED MODULE: ./src/layout/layouts/standard/standard.tsx

 //import N50Breadcrumb from '$features/Navigation/components/N50Breadcrumb';








const Standard = _ref => {
  let {
    children
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(features/* MetaFields */.L6, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(N10Meta_N10Meta, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(N20MainMenu_N20MainMenu, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("main", {
      className: (layouts_module_default()).main,
      children: children
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CookieConsent, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(N60Footer_N60Footer, {})]
  });
};
;// CONCATENATED MODULE: ./src/layout/layouts/standard/index.ts


/***/ }),

/***/ 6635:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"n10Meta":"N10Meta_n10Meta__NhDc6","content":"N10Meta_content__HoCaI","link":"N10Meta_link__ooisW","innerContent":"N10Meta_innerContent__aL1Rh","list":"N10Meta_list___dXR3"};

/***/ }),

/***/ 85980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uspContainer":"Usp_uspContainer__3CLcX","wrapper":"Usp_wrapper__d5Go2","accesibilityUspDisplay":"Usp_accesibilityUspDisplay__6KNw6","liWrapper":"Usp_liWrapper__IoSTS"};

/***/ }),

/***/ 53075:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainNavigation":"N20MainMenu_mainNavigation__yleo4","searchBoxPlaceholder":"N20MainMenu_searchBoxPlaceholder__NZ_tv","logoContainer":"N20MainMenu_logoContainer__kKqfC","iconNav":"N20MainMenu_iconNav__GaPJg","desktopNav":"N20MainMenu_desktopNav__WlgBM","line":"N20MainMenu_line__UrrFC","content":"N20MainMenu_content__oU9mc","loggedIn":"N20MainMenu_loggedIn__z3YlI"};

/***/ }),

/***/ 97885:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"iconBadge":"BasketButton_iconBadge__LG6Z5","buttonPadding":"BasketButton_buttonPadding__Qvhp9"};

/***/ }),

/***/ 91083:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonPadding":"FavoriteButton_buttonPadding__wL87E"};

/***/ }),

/***/ 95932:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonPadding":"LoginButton_buttonPadding__NK5iD","loginText":"LoginButton_loginText__HvADt","link":"LoginButton_link__YMTGQ"};

/***/ }),

/***/ 22665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobileMenuButton":"MobileMenuButton_mobileMenuButton__3dDFk"};

/***/ }),

/***/ 73372:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"N25SearchBar_searchBox__2u4f6","searchButton":"N25SearchBar_searchButton__5noNs"};

/***/ }),

/***/ 70046:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"N30MegaMenu_list___9gcw","dropDown":"N30MegaMenu_dropDown__jthsz","dropDownContent":"N30MegaMenu_dropDownContent__saFl9","dropDownMaxWidth":"N30MegaMenu_dropDownMaxWidth__tWc0p","dropDownOverlay":"N30MegaMenu_dropDownOverlay__XOBRf"};

/***/ }),

/***/ 30327:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Backdrop_backdrop__kvWXY"};

/***/ }),

/***/ 9745:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"Menu_menuWrapper__AK799","menu":"Menu_menu__X8wsU"};

/***/ }),

/***/ 93345:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigationItem":"NavigationItem_navigationItem__ahLtJ","privateLink":"NavigationItem_privateLink__xtmEF","active":"NavigationItem_active__jpodC"};

/***/ }),

/***/ 93628:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promotedContent":"PromotedChildren_promotedContent__QTlnY","promotedItem":"PromotedChildren_promotedItem__nbIp_","itemOverlay":"PromotedChildren_itemOverlay__B5XEC","info":"PromotedChildren_info__kY3ju","coverLink":"PromotedChildren_coverLink__HXmd6"};

/***/ }),

/***/ 14813:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"drawerContainer":"Drawer_drawerContainer__Myl1M","drawer":"Drawer_drawer__JoWdJ","fadeOut":"Drawer_fadeOut__3ppfc","open":"Drawer_open__Lrmsr","fadeIn":"Drawer_fadeIn__CwbOU","backdrop":"Drawer_backdrop__VIN_a","content":"Drawer_content__2Wieu"};

/***/ }),

/***/ 2309:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menuPage":"MenuPage_menuPage__pNj93","header":"MenuPage_header__HF_R4","backContainer":"MenuPage_backContainer__p81Vu"};

/***/ }),

/***/ 33011:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"MobileMetaMenu_list__m2M3Z","link":"MobileMetaMenu_link__Wk_TU"};

/***/ }),

/***/ 78530:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"NodeItem_content__sqmOb","loginHidden":"NodeItem_loginHidden__QU6P1","nodeButton":"NodeItem_nodeButton__ic_wa","nodeLink":"NodeItem_nodeLink__e8PbQ"};

/***/ }),

/***/ 52508:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listItem":"NodeList_listItem__J_IIO"};

/***/ }),

/***/ 43906:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"marketSelector":"MarketSelector_marketSelector__8dD_u","marketSelectorLabel":"MarketSelector_marketSelectorLabel__YPokn"};

/***/ }),

/***/ 78937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"layouts_main__wYBmo"};

/***/ }),

/***/ 38457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _useTimeoutFn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46583);


function useDebounce(fn, ms, deps) {
    if (ms === void 0) { ms = 0; }
    if (deps === void 0) { deps = []; }
    var _a = (0,_useTimeoutFn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(fn, ms), isReady = _a[0], cancel = _a[1], reset = _a[2];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(reset, deps);
    return [isReady, cancel];
}


/***/ }),

/***/ 34176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _misc_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88390);


var getInitialState = function (query, defaultState) {
    // Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
    if (defaultState !== undefined) {
        return defaultState;
    }
    if (_misc_util__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU) {
        return window.matchMedia(query).matches;
    }
    // A default value has not been provided, and you are rendering on the server, warn of a possible hydration mismatch when defaulting to false.
    if (false) {}
    return false;
};
var useMedia = function (query, defaultState) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function () {
            if (!mounted) {
                return;
            }
            setState(!!mql.matches);
        };
        mql.addListener(onChange);
        setState(mql.matches);
        return function () {
            mounted = false;
            mql.removeListener(onChange);
        };
    }, [query]);
    return state;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMedia);


/***/ })

}]);